/* AMYO 2026-09-09: keeps the free-shipping progress line in sync with the vendor
   <free-shipping-bar> element (theme.js sets `total-price` in cents on cart:change). */
(function () {
  if (window.__amyoFsbProgress) return;
  window.__amyoFsbProgress = true;

  function update(el) {
    var threshold = parseFloat(el.getAttribute('data-threshold-cents'));
    var total = parseFloat(el.getAttribute('total-price'));
    if (!(threshold > 0) || isNaN(total)) return;
    var pct = Math.max(0, Math.min(100, Math.floor((total / threshold) * 100))); /* floor: matches Liquid divided_by, never 100% before the threshold */
    el.style.setProperty('--fsb-progress', pct + '%');
    var track = el.querySelector('.free-shipping-bar__track');
    if (track) track.setAttribute('aria-valuenow', String(pct));
  }

  function bind(el) {
    if (el.__amyoBound) return;
    el.__amyoBound = true;
    new MutationObserver(function () { update(el); }).observe(el, { attributes: true, attributeFilter: ['total-price'] });
    update(el);
  }

  function bindAll(root) {
    (root || document).querySelectorAll('free-shipping-bar.free-shipping-bar--ao').forEach(bind);
  }

  bindAll();
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) bindAll(added[j]);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
